const routeFundraiser = '/fundraiser'

const FUNDRAISER_ROUTES = {
  fundraiser: {
    root: {
      key: 'fundraiser',
      title: 'سرمایه پذیری زیما',
      name: 'سرمایه پذیری زیما',
      href: `${routeFundraiser}`,
    },
    auth: {
      key: 'fundraiserAuth',
      title: 'ورود به پنل سرمایه پذیر زیما',
      name: 'ورود / ثبت‌نام پنل سرمایه پذیر زیما',
      href: `${routeFundraiser}/auth`,
    },
    register: {
      key: 'fundraiserRegister',
      title: 'ثبت نام به عنوان سرمایه پذیر در زیما',
      name: 'ثبت نام به عنوان سرمایه پذیر در زیما',
      href: `${routeFundraiser}/auth/register`,
    },
    loginOtp: {
      key: 'fundraiserOtp',
      title: 'ورود به پنل سرمایه پذیر زیما',
      name: 'ورود / ثبت‌نام پنل سرمایه پذیر زیما',
      href: `${routeFundraiser}/auth/login-by-otp`,
    },
    loginPassword: {
      key: 'fundraiserPassword',
      title: 'ورود به پنل سرمایه پذیر زیما',
      name: 'ورود / ثبت‌نام پنل سرمایه پذیر زیما',
      href: `${routeFundraiser}/auth/login-by-password`,
    },
    setPassword: {
      key: 'fundraiserSetPassword',
      title: 'ثبت رمز عبور',
      name: 'ثبت رمز عبور',
      href: `${routeFundraiser}/auth/set-password`,
    },
    additionalInfo: {
      key: 'fundRegisterAdditionalInfo',
      title: 'اطلاعات تکمیلی ثبت نام',
      name: 'اطلاعات تکمیلی ثبت نام',
      href: `${routeFundraiser}/auth/additional-info`,
    },
    dashboard: {
      root: {
        key: 'fundraiserDashboard',
        title: 'داشبورد سرمایه پذیر',
        name: 'داشبورد سرمایه پذیر',
        href: `${routeFundraiser}/dashboard`,
      },
      requests: {
        key: 'fundDashRequests',
        title: 'درخواست ها',
        name: 'درخواست ها',
        href: `${routeFundraiser}/dashboard/requests`,
      },
      request: {
        key: 'fundDashRequest',
        title: 'درخواست ',
        name: 'درخواست',
        href: `${routeFundraiser}/dashboard/requests`,
      },
      newRequest: {
        key: 'fundDashRequests',
        title: 'ثبت درخواست جدید',
        name: 'ثبت درخواست جدید',
        href: `${routeFundraiser}/dashboard/requests`,
      },
      rules: {
        key: 'rules',
        title: 'قوانین و مقررات',
        name: 'قوانین و مقررات',
        href: `${routeFundraiser}/rules`,
      },
      faq: {
        key: 'faq',
        title: 'پرسش‌های متداول',
        name: 'پرسش‌های متداول',
        href: `${routeFundraiser}/faq`,
      },
    },
  },
}

export default FUNDRAISER_ROUTES
